import React from "react";
import ConfigSection from "../../ConfigSection";

const MailTemplateSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Mail Template'
      configType='MailTemplate'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default MailTemplateSection;
